module.exports = __webpack_public_path__ + "3d8fb4a378848116ba80bca521819cec.svg";